import React, { useCallback } from 'react';
import locale from 'antd/es/date-picker/locale/ja_JP';
import { DatePicker, Radio, Row } from 'antd';

import dayjs from 'dayjs';
import style from './index.module.scss';

/**
 * カスタム日付Pickerのプロパティ
 */
type Props = {
  title: string;
  type: 'none' | 'range' | 'day';
  from?: string;
  to?: string;
  onChange: (type: 'none' | 'range' | 'day', from?: string, to?: string) => void;
};

/**
 * カスタム日付Picker
 * @param title
 * @param type
 * @param from
 * @param to
 * @param onChange
 * @constructor
 */
export const CustomDatePicker: React.FC<Props> = ({ title, type, from, to, onChange }) => {
  const toDate = (str: string | undefined) => (str ? dayjs(str, 'YYYY-MM-DD') : undefined);
  const rangeValue: [dayjs.Dayjs, dayjs.Dayjs] = type === 'range' ? [toDate(from), toDate(to)] : undefined;
  const dayValue = type === 'day' ? toDate(from) : undefined;

  const update = useCallback(({ newType, newFrom, newTo }: { newType?: 'none' | 'range' | 'day', newFrom?: dayjs.Dayjs, newTo?: dayjs.Dayjs }) => {
    const { tp, f, t } = { tp: newType ?? type, f: newFrom ?? toDate(from), t: newTo ?? toDate(to) };
    const fromStr = f?.format('YYYY-MM-DD') ?? undefined;
    const toStr = t?.format('YYYY-MM-DD') ?? undefined;
    if (tp === 'range') {
      onChange(tp, fromStr, toStr);
      return;
    }
    if (tp === 'day') {
      onChange(tp, fromStr, fromStr);
      return;
    }
    onChange('none');
  }, [onChange]);

  return (
    <Row className={style.row}>
      <div className={style.formLabel}>
        {title}
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>
          <Radio.Group value={type} onChange={(tp) => update({ newType: tp.target.value })}>
            <Radio value={'none'}>指定なし</Radio>
            <Radio value={'range'}>
              期間指定&nbsp;&nbsp;&nbsp;&nbsp;
              <DatePicker.RangePicker value={rangeValue} onChange={(v) => update({ newFrom: v[0], newTo: v[1] })} locale={locale} allowEmpty={type !== 'range'} disabled={type !== 'range'} />
            </Radio>
            <Radio value={'day'}>
              日付指定&nbsp;&nbsp;&nbsp;&nbsp;
              <DatePicker locale={locale} value={dayValue} onChange={(v) => update({ newFrom: v })} disabled={type !== 'day'} />
            </Radio>
          </Radio.Group>
        </div>
      </div>
    </Row>
  );
};
